import React from 'react';
import SignUpModal from '../../components/modals/SignUp/SignUp';
import LightPillar from '../../components/LightPillar/LightPillar';

const Default: React.FC = () => {
  return (
    <>
      {/* Hero Section - Full Viewport */}
      <section className="hero-landing">
        <LightPillar
          topColor="#29e6ff"
          bottomColor="#9effcd"
          mixBlendMode="lighten"
          rotationSpeed={0.2}
          glowAmount={0.006}
        />
        <div className="hero-content">
          <h1 className="hero-title">
            Voyage Calculations<br />
            <span className="hero-highlight">Made Simple</span>
          </h1>
          <p className="hero-subtitle">
            Streamline your maritime operations with powerful, intuitive voyage estimation tools.
          </p>
          <SignUpModal />
        </div>
        <div className="scroll-indicator">
          <i className="bi bi-chevron-down"></i>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-container">
          <h2 className="features-title">Why VoyCalc?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="bi bi-speedometer2"></i>
              </div>
              <h3>Fast Estimates</h3>
              <p>Create accurate voyage estimates in minutes by efficient re-use of your own data!</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="bi bi-globe"></i>
              </div>
              <h3>Global Routes</h3>
              <p>Access worldwide port data and calculate optimal routes.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="bi bi-graph-up"></i>
              </div>
              <h3>Smart Analytics</h3>
              <p>Compare options with a click, and make data-driven decisions.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="bi bi-cloud-check"></i>
              </div>
              <h3>Cloud Based</h3>
              <p>Access your estimates anywhere, anytime, on any device.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Default;
